var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-card w-100 rounded p-2 px-3",class:{ [`status-card--${_vm.status}`]: _vm.status }},[_c('h4',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.title))]),_c('h2',{staticClass:"text-bold"},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }